import React, { useEffect } from 'react';
import JsonForm from 'components/dynamic-form/json-form';
import { useDispatch, useSelector } from 'react-redux';
import { ShippingClient } from 'clients/shipping-client';
import { notifyError } from 'actions/action-notifications';
import providerBuilder from '../providers/provider-builder';
import taskProviderHoc from './task-form-hoc';
import { FDC } from '../../../constants/index';

const TaskDetailForm = props => {
  const { taskType, task, taskStatusId, paymentMethods } = props;
  const [dataState, setDataState] = React.useState();
  const pharmacies = useSelector(state => state.pharmacies?.pharmacies || []);
  const dispatch = useDispatch();

  async function getFCData(orderId) {
    try {
      const response = await ShippingClient.fetch(orderId, 'task-detail-form');
      if (response.data.error) {
        dispatch(notifyError(response.data.error));
      } else {
        setDataState(response.data);
      }
    } catch (_error) {
      dispatch(notifyError('Failed to load order details.'));
    }
  }

  // Therapies Tab - Archived FDC
  useEffect(() => {
    setDataState(undefined);
    if (task.order_id && taskType === FDC) {
      getFCData(task.order_id);
    }
  }, [task.id, task.order_id, taskType]);

  const providers = providerBuilder(taskType)(
    task,
    { ...props, pharmacies, paymentMethods: { ...paymentMethods } },
    dataState,
  );

  return providers ? (
    <JsonForm
      jsonForm={providers.json}
      formName="view"
      formId={`view-${taskType}-${task.id}`}
      data={task}
      providers={providers}
      readOnly
      taskStatusId={taskStatusId}
    />
  ) : null;
};

export default taskProviderHoc(TaskDetailForm, true);
